AccountPasswordController.$inject = ['API', '_', 'alerts'];

/* @ngInject */
function AccountPasswordController(API, _, alerts) {
    var vm = this;
    vm.title = 'AccountPasswordController';

    vm.loading = {
        password: false,
        code: false
    };

    vm.password = {
        old: '',
        new: '',
        new_confirmation: ''
    };
    vm.code = {
        password: ''
    };

    vm.save_password = save_password;

    vm.save_code = save_code;

    activate();

    ////////////////

    function activate() {
    }

    function save_password() {
        var data = password_formatData();
        vm.loading.password = true;

        API.one('account').customPUT(data, 'password')
            .then(function () {
                alerts.success('¡Exito!', 'Tu contraseña se cambió con éxito');
                password_reserFields();
            })
            .catch(alerts.errorHandler)
            .finally(function () {
                vm.loading.password = false;
            });
    }

    function save_code() {
        var data = code_formatData();
        vm.loading.code = true;

        API.one('account').customPUT(data, 'code')
            .then(function () {
                alerts.success('¡Exito!', 'Se envió tu nuevo código a tu email');
                code_reserFields();
            })
            .catch(alerts.errorHandler)
            .finally(function () {
                vm.loading.code = false;
            });
    }

    function password_formatData() {
        return {
            old_password: vm.password.old,
            password: vm.password.new,
            password_confirmation: vm.password.new_confirmation
        };
    }

    function password_reserFields() {
        var pw = vm.password;
        pw.old = '';
        pw.new = '';
        pw.new_confirmation = '';
    }

    function code_formatData() {
        return {
            password: vm.code.password
        };
    }

    function code_reserFields() {
        vm.code.password = '';
    }
}

export default AccountPasswordController;